import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//弹出mailmerge的div
export function docMergeJobAspectCertificate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.JobAspectCertificateId, dataModelType: 7 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(7);
  }, config.setTimeoutMilliSecond);
}
